export default __webpack_public_path__ + "85c128721035823e5405031e066d0918.woff2";